var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scroller",staticClass:"chat-thread"},[_vm._l((_vm.messages),function(msg,index){return _c('ChatMessage',{key:msg.id,attrs:{"message":msg,"is-last":index === _vm.messages.length - 1}})}),(_vm.isLoading)?_c('div',{staticClass:"chat-thread__typing"},[_c('span'),_c('span'),_c('span')]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }